import React from "react"
import { testId } from "../../../../utility/tests/testId/knowledgeBase"
import styles from "./CategoryIcon.module.scss"

interface CategoryIconProps {
    icon: JSX.Element
    onClick?: () => void
}

const CategoryIcon = (props: CategoryIconProps) => {
    const { icon, onClick } = props

    return (
        <div className={styles.icon} onClick={onClick} data-testid={testId.categoryToggleIcon}>
            <div className={styles.icon__toggle}>{icon}</div>
        </div>
    )
}

export default CategoryIcon
